import { buildShadowValue } from 'src/js/modules/breakpoint-editing/helpers/build-shadow-value';
import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';
import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';
import settingIds from '../../constants/setting-ids';
import { shadowTargets } from '../../constants/targets';

const SHADOW_ENABLED_VALUE = buildShadowValue('0px', '6px', '20px', '0px', 'rgba(0,0,0,0.18)');

export default [
  {
    scope: settingIds.THIS_COLUMN,
    attribute: targetAttributes.SHADOW,
    classes: shadowTargets,
    convert: () => ({ [breakpointKeys.DEFAULT]: SHADOW_ENABLED_VALUE }),
  },
];

export { SHADOW_ENABLED_VALUE };
